/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type SearchSubscriptionsRequest = {
  /**
   * The page number for pagination.
   */
  pageNumber?: number | undefined;
  /**
   * The number of items per page.
   */
  pageSize?: number | undefined;
};

/** @internal */
export const SearchSubscriptionsRequest$inboundSchema: z.ZodType<
  SearchSubscriptionsRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  page_number: z.number().default(1),
  page_size: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    "page_number": "pageNumber",
    "page_size": "pageSize",
  });
});
/** @internal */
export type SearchSubscriptionsRequest$Outbound = {
  page_number: number;
  page_size: number;
};

/** @internal */
export const SearchSubscriptionsRequest$outboundSchema: z.ZodType<
  SearchSubscriptionsRequest$Outbound,
  z.ZodTypeDef,
  SearchSubscriptionsRequest
> = z.object({
  pageNumber: z.number().default(1),
  pageSize: z.number().default(10),
}).transform((v) => {
  return remap$(v, {
    pageNumber: "page_number",
    pageSize: "page_size",
  });
});

export function searchSubscriptionsRequestToJSON(
  searchSubscriptionsRequest: SearchSubscriptionsRequest,
): string {
  return JSON.stringify(
    SearchSubscriptionsRequest$outboundSchema.parse(searchSubscriptionsRequest),
  );
}
export function searchSubscriptionsRequestFromJSON(
  jsonString: string,
): SafeParseResult<SearchSubscriptionsRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SearchSubscriptionsRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SearchSubscriptionsRequest' from JSON`,
  );
}
